const transformEntity = (obj) => {
  const newObject = {};
  if (!newObject.id && obj.id) {
    newObject.id = obj.id;
  }
  Object.keys(obj.attributes || {}).forEach((attr) =>
    transformKey(attr, obj, newObject)
  );
  return newObject;
};

const transformComponent = (obj) => {
  const newObject = {};
  if (!newObject.id && obj.id) {
    newObject.id = obj.id;
  }
  Object.keys(obj).forEach((attr) => transformKey(attr, obj, newObject));
  return newObject;
};

const transformCollection = (obj) => {
  return obj.map((o) => transformEntity(o));
};

const transformComponentList = (obj) => {
  return obj.map((o) => transformComponent(o));
};

function transformObject(obj) {
  if (Array.isArray(obj.data)) {
    return transformCollection(obj.data);
  }

  if (obj.data) {
    return transformEntity(obj.data);
  }

  if (obj.data === null) {
    return null;
  }

  if (Array.isArray(obj)) {
    return transformComponentList(obj);
  }

  return transformComponent(obj);
}

function transformKey(attr, obj, newObject) {
  if (!newObject.id && obj.id) {
    newObject.id = obj.id;
  }

  // preserve null values
  let value = obj?.attributes?.[attr];
  value = value === undefined ? obj[attr] : value;
  execKeyScenarios(attr, value, newObject);
}

function execKeyScenarios(attr, value, newObject) {
  if (value === null) {
    newObject[attr] = null;
  } else if (typeof value === "object") {
    newObject[attr] = transformObject(value);
  } else {
    newObject[attr] = value;
  }
}
module.exports.transformObject = transformObject;
